import axios from 'axios';
import countries from '../country.json'

const getApiPrefixPath = countryCode => countries[countryCode].host + '/core-home-proxy/cauth/widgets'

const WidgetApi = {

  getBanners: async (countryCode, token) => {
    try {
        const response = await axios.get(getApiPrefixPath(countryCode) + '/cms/widgets/type/banners', {
            headers: { Authorization: `Bearer ${token}` },
        });

      return response.data.filter(widget => widget.data.length > 0);
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  getCarousels: async (countryCode, token) => { // TODO: remove duplicated code betwn getBanners & getCarousels
    try {
        const response = await axios.get(getApiPrefixPath(countryCode) + '/cms/widgets/type/carousel', {
            headers: { Authorization: `Bearer ${token}` },
        });

        return response.data.filter(widget => 
          widget.additional_information?.merchandising ?? false
        );
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  updateWidget: async (countryCode, updatedWidget, token) => {
    try {
        const response = await axios.put(getApiPrefixPath(countryCode) + '/widgets', updatedWidget, {
            headers: { Authorization: `Bearer ${token}` },
        });

      return response.data
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
};


export default WidgetApi;
